<template>
  <a-flex class="root">
    <a-col :span="24">
      <div class="instructions">
        На этой странице Вы можете отслеживать, по каким научным направлениям
        выполнялись проекты этого портфеля.
      </div>
    </a-col>

    <a-col :span="24" v-if="udc.length > 0 && !isLoading">
      <scopes-circle-chart :data="getWrappedData(udc)" />
    </a-col>
  </a-flex>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import { useApi } from '@/api/use-api';
  import { useRoute } from 'vue-router';
  import ScopesCircleChart from '@/components/projects/portfolio/components/ScopesCircleChart.vue';

  const api = useApi();
  const route = useRoute();
  const udc = ref([]);
  const isLoading = ref(true);

  onMounted(async () => {
    await getStats();
    isLoading.value = false;
  });

  const getStats = async () => {
    try {
      const response = await api.briefcaseUdc.statsGraph(
        new URLSearchParams({
          briefcaseId: route.params.id,
        })
      );
      udc.value = response.stats.items;
    } catch (error) {
      console.error('error', error);
    }
  };

  const getWrappedData = (data) => {
    const rootCount = data.reduce((acc, item) => acc + item.count, 0);
    return {
      udcClassId: 0,
      notation: '',
      caption: '',
      count: rootCount,
      level: 0,
      items: data,
    };
  };
</script>

<style scoped lang="scss">
  @use "@/assets/styles/_colors.scss" as *;

  * {
    font-family: 'Nunito Sans', sans-serif;
  }

  .root {
    flex-direction: column;

    .instructions {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 40px;
      max-width: 555px;
    }

    .empty-card {
      background-color: $color-bg-secondary-grey;
      border-radius: 7px;
      flex-direction: column;
      max-width: 900px;
      padding: 20px;
      width: 100%;
      margin-top: 40px;

      .title {
        color: $color-table-text-secondary;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
      }
    }

    .scopes {
      flex-direction: column;
      row-gap: 40px;
      margin-top: 40px;
    }
  }
</style>
